import React from "react";
import ActivityLogs from "../../../Components/ActivityLogs";
import { Card } from "react-bootstrap";

interface ActivityLogsProps {
  id: number;
}

const ActivityLog: React.FC<ActivityLogsProps> = ({ id }) => {
  return (
    <>
      <Card className="min-height-card">
        <Card.Header className="">Activity Logs</Card.Header>
        <Card.Body>
          <ActivityLogs auditable_type={"ORGANIZATION"} id={id} width={"95%"} />
        </Card.Body>
      </Card>
    </>
  );
};

export default ActivityLog;
